// src/calc.ts
function toExpression(operator, ...args) {
  return args.join(` ${operator} `).replace(/calc/g, "");
}
function add(...args) {
  return `calc(${toExpression("+", ...args)})`;
}
function subtract(...args) {
  return `calc(${toExpression("-", ...args)})`;
}
function multiply(...args) {
  return `calc(${toExpression("*", ...args)})`;
}
function divide(...args) {
  return `calc(${toExpression("/", ...args)})`;
}
function negate(value) {
  if (!isNaN(parseFloat(value.toString())))
    return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
  return multiply(value, -1);
}
var calc = Object.assign(
  (x) => ({
    add: (...args) => calc(add(x, ...args)),
    divide: (...args) => calc(divide(x, ...args)),
    multiply: (...args) => calc(multiply(x, ...args)),
    negate: () => calc(negate(x)),
    subtract: (...args) => calc(subtract(x, ...args)),
    toString: () => x.toString()
  }),
  {
    add,
    divide,
    multiply,
    negate,
    subtract
  }
);

export {
  calc
};
//# sourceMappingURL=chunk-5J34UVTP.mjs.map